<template>
  <Breadcrumbs title="ชำระเงินและดาวน์โหลดรูป" main="Pages" />
  <div class="container-fluid">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body">
              <div class="row">&nbsp;</div>
              <div class="row">&nbsp;</div>
              <div class="row">
                <div class="d-flex justify-content-center">
                  <img
                    style="width: 300px"
                    src="../../assets/images/logo/logo.png"
                  />
                </div>
              </div>
              <div class="row">&nbsp;</div>
              <div class="row">
                <div class="d-flex justify-content-center">
                  <h4>คำสั่งซื้อ: {{ this.order_uuid }}</h4>
                </div>
              </div>
              <div v-if="this.payment_status">
                <div class="row" v-if="this.payment_status !== 'PAID'">
                  <div class="d-flex justify-content-center">
                    <h4 style="color: red">สถานะ : รอชำระเงิน</h4>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b>จำนวน: {{ this.amount }} บาท</b>
                  </div>
                </div>
                <div class="row" v-if="this.payment_status === 'PAID'">
                  <div class="d-flex justify-content-center">
                    <h4 style="color: green">สถานะ : ชำระเงินเรียบร้อย</h4>
                  </div>
                </div>
              </div>

              <div class="row" v-if="this.payment_status !== 'PAID'">
                <div class="d-flex justify-content-center">
                  <div v-if="this.payment_api_response.qrcode">
                    <vue-qrcode
                      :value="this.payment_api_response.qrcode"
                      :options="{
                        errorCorrectionLevel: 'Q',
                        width: 300,
                      }"
                      @ready="onReady"
                    ></vue-qrcode>
                  </div>
                </div>
                <div class="d-flex justify-content-center" v-if="this.payment_status !== null">
                  <b v-if="this.payment_status === 'INITIAL'"><i class="fa fa-info-circle"></i>  <u>หากใช้งานบนอุปกรณ์โทรศัพท์มือถือ สามารถแคปหน้าจอ เพื่อเอา QRCode ไปสแกนจ่ายพร้อมเพย์ได้เลย</u></b>
                </div>
                <div class="d-flex justify-content-center" v-if="this.payment_status !== null">
                  <p v-if="this.payment_status === 'INITIAL'">ติดปัญหาในการใช้งานสามารถสอบถามข้อมูลเพิ่มเติมได้ที่ LineID:<a target="_blank" href="https://lin.ee/nMKDW7X">@sportaction.in.th</a><br /></p>
                </div>
                
                <p></p>
                <div class="d-flex justify-content-center">
                  <div v-if="this.payment_api_response.qrcode">
                    <a class="btn btn-primary btn-lg" href="" role="button">
                      <vue-feather type="refresh-cw" size="18"> </vue-feather>
                      กดปุ่ม Refresh เมื่อชำระเงินเรียบร้อย</a
                    >
                  </div>
                  <div v-if="!this.payment_api_response.qrcode">
                    <b>
                      <img
                        style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
                    </b>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <div v-if="!this.payment_api_response.qrcode">
                    <b> กำลังโหลดข้อมูลกรุณารอสักครู่... </b>
                  </div>
                </div>
              </div>
              <div class="row">&nbsp;</div>
              <div class="row"></div>
              
              <div class="row">
                
                <div class="card-body">
                  <div class="d-flex justify-content-center" v-if="this.payment_status !== null ">

                    <h6 v-if="this.payment_status === 'INITIAL'">(รูปตัวอย่างจำนวน {{ this.images_order.length }} รูป) รูปต้นฉบับความละเอียดสูงจะสามารถดาวน์โหลดได้หลังจากชำระเงิน</h6>

                  </div>
                <div class="container-fluid">
                  <figure
                          v-for="(src, index) in this.images_order"
                          :key="index"
                        >
                          <div class="gallery gellerycont">
                            <img
                              loading="lazy"
                              style="background: url('https://ishootrun.in.th/ishootrun-img/ishootrun_loading.svg') center center no-repeat rgb(238, 238, 238);"
                              :src="src.thumbnail_file_name"
                              :alt="src.original_file_name"
                            />
                            </div>
                </figure>
              </div>
            </div>
              </div>
              <div class="row" v-if="this.payment_status === 'PAID'">
                <div class="row">
                  <div class="card">
                    <div class="stepper-wrapper">
                      <div class="stepper-item completed">
                        <div class="step-counter">1</div>
                        <div class="step-name">ชำระเงินสำเร็จ</div>
                      </div>
                      <div class="stepper-item completed">
                        <div class="step-counter">2</div>
                        <div class="step-name">เตรียมรูปต้นฉบับ</div>
                      </div>
                      
                      <div class="stepper-item completed" v-if="this.is_logo_image_created === 'Y'">
                        <div class="step-counter">3</div>
                        <div class="step-name">เตรียมรูปติดโลโก้</div>
                      </div>
                      <div class="stepper-item active" v-else>
                        <div class="step-counter"><vue-feather type="loader" size="13" animation="spin" ></vue-feather></div>
                        <div class="step-name">เตรียมรูปติดโลโก้</div>
                      </div>
                      <div class="stepper-item completed" v-if="this.is_logo_image_created === 'Y'">
                        <div class="step-counter">4</div>
                        <div class="step-name">เสร็จสมบูรณ์</div>
                      </div>
                      <div class="stepper-item" v-else>
                        <div class="step-counter">4</div>
                        <div class="step-name">เสร็จสมบูรณ์</div>
                      </div>
                    </div>
                  </div>
                  </div>

                <div class="row">
                  <div class="card">
                    <div class="card-body">
                      <!-- <p style="color: red" v-if="this.is_logo_image_created !== 'Y'">
                        <vue-feather type="info" size="14" ></vue-feather>  รูปติดโลโก้อาจจะใช้เวลาในการจัดเตรียมสักครู่  (ระยะเวลาขึ้นอยู่กับจำนวนรูป)
                        , โดยระหว่างนี้ท่านสามารถดาวน์โหลดรูปต้นฉบับได้ทันที โดยกดปุ่มบนรูปภาพ
                      </p> -->
                      <p><b><vue-feather type="info" size="12" ></vue-feather> คำแนะนำในการดาวน์โหลดรูป</b>
                        <ui>
                          <li>กด View ที่รูปเพื่อเปิด แล้วกดค้างที่รูป เพื่อเลือกบันทึกลงอุปกรณ์</li>
                          <li>ระบบส่งลิ้งค์สำหรับดาวน์โหลดภาพให้ทาง SMS หรือ อีเมลล์ให้ <b style="color: red;"><u>หากไม่ได้รับ สามารถค้นหาได้ที่เมนู</u> <a href="../find-order" target="_blank">"ค้นหาคำสั่งซื้อ"</a></b></li>
                          <li>รูปจะจัดเก็บในระบบประมาณ 35 วันหลังจากวันที่จัดกิจกรรม</li>
                        </ui>
                      </p>
                      <p>
                        <ui>
                          <li>ปุ่มดาวน์โหลดรูปทั้งหมด จะแสดงเมื่อใช้งานบนอุปกรณ์คอมพิวเตอร์ ระบบจะเปิดแทบเท่ากับจำนวนรูป เพื่อดาวน์โหลด</li>
                          <li>หากติดปัญหาในการใช้งาน สามารถสอบถามข้อมูลเพิ่มเติมได้ที่ Line: <a target="_blank" href="https://lin.ee/nMKDW7X">@ishootrun.in.th</a></li>
                        </ui>
                      </p>
                      
                      <div class="row">
                        <div
                          class="col-xl-4 col-sm-12"
                          style="text-align: center"
                        >
                          <a
                            class="btn btn-primary btn-sm"
                            href=""
                            role="button" style="width: 80%"
                            ><vue-feather type="refresh-cw" size="18">
                            </vue-feather>
                            Refresh</a
                          >
                        </div>
                        <div
                          class="col-xl-4 col-sm-12"
                          style="text-align: center;margin-top: 3px;"
                        >
                        <button v-if="this.is_original_image_created  === 'Y' && this.windowWidth > 1050" style="width: 80%" type="button" @click.prevent="load_all_images()" class="btn btn-primary"><vue-feather type="download-cloud" size="18">
                            </vue-feather>
                            ดาวน์โหลดรูปทั้งหมด</button>
                        </div>
                        <div class="col-xl-4 col-sm-12" style="text-align: center;margin-top: 3px;" >
                        <button v-if="this.is_logo_image_created === 'Y' && this.windowWidth > 1050" style="width: 80%" type="button" @click.prevent="load_all_images_logo()" class="btn btn-primary">
                          <vue-feather type="download-cloud" size="18"> </vue-feather> ดาวน์โหลดรูปทั้งหมด ที่มี Logo
                        </button>
                        <button v-if="this.is_logo_image_created !== 'Y' && this.windowWidth > 1050" style="width: 80%;background-color: rgb(226, 226, 226) ;" type="button" class="btn" disabled>
                          <vue-feather type="loader" animation="spin" size="15"> </vue-feather> รูปติดโลโก้กำลังจัดเตรียม...
                        </button>
                        </div>
                      </div>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">

                    <div class="d-flex justify-content-center" >
                      <!-- <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" class="btn-check" name="btnradio" id="btnradio1"  autocomplete="off" checked>
                        <label class="btn btn-outline-primary" @click="randerDownloadImage('ORIGINAL')" for="btnradio1"><vue-feather type="menu" size="14" ></vue-feather> รูปต้นฉบับ</label>

                        <input v-if="this.is_logo_image_created === 'Y'" type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                        <label v-if="this.is_logo_image_created === 'Y'" class="btn btn-outline-primary" @click="randerDownloadImage('LOGO')" for="btnradio2">รูปต้นฉบับ ติดโลโก้</label>

                        <input v-if="this.is_logo_image_created !== 'Y'" type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" disabled>
                        <label v-if="this.is_logo_image_created !== 'Y'" class="btn btn-outline-primary" @click="randerDownloadImage('LOGO')" for="btnradio2"><vue-feather type="loader" animation="spin" size="15"></vue-feather>  รูปติดโลโก้กำลังจัดเตรียม...</label>
                    </div> -->

                      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                          <input type="radio" class="btn-check" name="btnradio" id="btnradio1"  autocomplete="off" checked>
                          <label class="btn btn-outline-primary" @click="randerDownloadImage('ORIGINAL')" for="btnradio1"><vue-feather type="menu" size="14" ></vue-feather> รูปต้นฉบับ</label>

                          <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                          <label class="btn btn-outline-primary" @click="randerDownloadImage('LOGO')" for="btnradio2">รูปต้นฉบับ ติดโลโก้</label>

                        </div>
                    </div>
                                        
                    <div class="container-fluid">
                      <figure
                        v-for="(src, index) in this.payment_images_paid"
                        :key="index"
                        
                      >
                        <div class="gallery gellerycont">
                          <img
                            loading="lazy"
                            style="background: url('https://ishootrun.in.th/ishootrun-img/ishootrun_loading_bg_img.svg') center center no-repeat rgb(238, 238, 238);"
                            :src="this.s3_url + '' + src.image_thumbnail"
                            :alt="this.s3_url + '' + src.image_thumbnail"
                          />

                          <!-- <input type="checkbox" :id="src.id" /> -->
                          <label
                            v-if="this.is_download_original_image==='Y'" 
                            class="btn-download btn-primary"
                            @click.prevent="this.download(this.s3_url + src.image)" :for="src.id" >Download</label>

                          <label
                            v-if="this.is_download_original_image!=='Y'"
                            class="btn-download btn-primary"
                            @click.prevent="this.download(this.s3_url + src.image_logo)" :for="src.id" >Download+logo</label >
                        </div>
                      </figure>

                      <vue-easy-lightbox
                        pinchDisabled="true"
                        scrollDisabled="true"
                        :zoomDisabled=false
                        loop="true"
                        rotateDisabled="true"
                        moveDisabled="true"
                        :visible="visible"
                        :index="index"
                        :imgs="this.is_download_original_image==='Y'?lightbox_images_download:lightbox_images_download_logo"
                        @hide="handleHide"
                      >
                        <!-- <template v-slot:close-btn="{  }">
                      
                      </template> -->

                        <template v-slot:toolbar="{}">
                          <!-- <button @click="toolbarMethods.zoomIn">zoom in</button>
                        <button @click="toolbarMethods.zoomOut">zoom out</button>
                        <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
                        <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
                        </template>
                      </vue-easy-lightbox>
                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "../../store/modules/cart";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";

import { ref } from "vue";
const isBtnaddToCartClick = ref(0);
const isBtnshowImgClick = ref(0);
import { mapState } from "vuex";

export default {
  setup() {
    const cart_store = useCartStore();

    cart_store.loadFromLocalStorage();
    cart_store.clear_cart();

    return { cart_store };
  },
  data() {
    return {
      test: [],
      qr_code: "",
      order_uuid: this.$route.params.q,
      amount: null,
      mobile: null,
      email: null,
      amount: null,
      is_original_image_created: null,
      is_logo_image_created: null,
      is_send_sms: null,
      is_send_email: null,
      payment_status: null,
      images_order: [],
      payment_images_paid: [],
      payment_api_response: [],
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      is_loading: "",
      images_download_all: [],
      images_download_all_logo: [],
      event_key: null,

      lightbox_images_download: [],
      lightbox_images_download_logo: [],
      visible: false,
      index: "",
      is_download_original_image: "Y",

      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      sidebar: (state) => state.layout.sidebarType,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
    }),
  },
  watch: {
    width() {
      this.windowWidth = window.innerWidth;
      //console.log("Logo.innerWidth watch :" + window.innerWidth);
    },
  },
  async beforeCreate() {
    this.is_loading = "Y";
    this.order_uuid = this.$route.params.q;
    const data = {
      tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
      order_uuid: this.order_uuid,
    };
    let response_data = await axios
      .post("/v1/order/inquiry", data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });

    //console.log("resultGetData", response_data);
    if (response_data.status === "success") {
      if (response_data.api_response !== null) {
        this.payment_api_response = JSON.parse(response_data.api_response);
      }
      this.payment_status = response_data.payment_status;
      this.status = response_data.status;
      this.mobile = response_data.mobile;
      this.email = response_data.email;
      this.amount = response_data.amount;
      this.is_original_image_created = response_data.is_original_image_created;
      this.is_logo_image_created = response_data.is_logo_image_created;
      this.is_send_sms = response_data.is_send_sms;
      this.is_send_email = response_data.is_send_email;
      this.event_key = response_data.event_key;
      
      if(this.payment_status === 'INITIAL'){
        this.images_order = JSON.parse(response_data.images_order);
      }
      if (response_data.images_paid !== null) {
        this.payment_images_paid = JSON.parse(response_data.images_paid);

        this.payment_images_paid.forEach((item) => {
          this.images_download_all.push(this.s3_url + item.image);
          this.images_download_all_logo.push(this.s3_url + item.image_logo);

          this.lightbox_images_download.push({
              src: this.s3_url + item.image
          });
          
          this.lightbox_images_download_logo.push({
              src: this.s3_url + item.image_logo
          });
        });
      }
    } else {
      await Swal.fire({
        position: "top-center",
        icon: "error",
        title:
          "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง, หรือติดต่อลูกค้าสัมพันธ์ที่ LINEID @ishootrun.in.th",
        showConfirmButton: true,
      });
    }
  },
  async beforeMount() {
    this.qr_code = "-";
  },
  methods: {
    async download(_url) {
      window.open(_url+ "?openExternalBrowser=1", "_blank");
    },async view_download(url) {
      
    }
    ,
    async sleep_only() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 200);
      });
    },
    async load_all_images() {
      let result = await Swal.fire({
        icon: "info",
        title:
          "<b style='color: red'><u>กรุณาเปิดอนุญาตป๊อปอัป</u></b> เมื่อเริ่มดาวน์โหลด,  ระบบจะดาวน์โหลดรูปทั้งหมด อัตโนมัติ จำนวน "+this.images_download_all.length +" รูป",
        html: "<b style='color: red'><u>ดาวน์โหลดรูปทั้งหมดแนะนำใช้งานผ่านคอมพิวเตอร์</u></b>,<br> บนระบบ ios(ไอโฟน) ระบบจะเปิดแทบเท่ากับจำนวนรูป เพื่อให้กดค้างบันทึก <br>คุณต้องการดาวน์โหลดรูปทั้งหมดใช่หรือไม่?",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#7991a8",
        confirmButtonText: "เริ่มดาวน์โหลด",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          let count = 0;
          while (count < this.images_download_all.length) {
            window.open(
              this.images_download_all[count] + "?openExternalBrowser=1",
              "_blank"
            );
            count++;
          }
        } else {
          return false;
        }
      });
    },
    async load_all_images_logo() {
      let result = await Swal.fire({
        icon: "info",
        title:
          "<b style='color: red'><u>กรุณาเปิดอนุญาตป๊อปอัป</u></b> เมื่อเริ่มดาวน์โหลด,  ระบบจะดาวน์โหลดรูปทั้งหมด อัตโนมัติ จำนวน "+this.images_download_all_logo.length +" รูป",
        html: "<b style='color: red'><u>ดาวน์โหลดรูปทั้งหมดแนะนำใช้งานผ่านคอมพิวเตอร์</u></b>,<br> บนระบบ ios(ไอโฟน) ระบบจะเปิดแทบเท่ากับจำนวนรูป เพื่อให้กดค้างบันทึก <br>คุณต้องการดาวน์โหลดรูปทั้งหมดใช่หรือไม่?",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#7991a8",
        confirmButtonText: "เริ่มดาวน์โหลด",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          let count = 0;
          while (count < this.images_download_all_logo.length) {
            window.open(
              this.images_download_all_logo[count] + "?openExternalBrowser=1",
              "_blank"
            );
            count++;
          }
        } else {
          return false;
        }
      });


    },
    onReady(canvas) {
      const context = canvas.getContext("2d");
      const image = new Image();

      image.src =
        "data:image/png;base64,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";
      image.crossorigin = "anonymous";
      image.onload = () => {
        const coverage = 0.15;
        const width = Math.round(canvas.width * coverage);
        const x = (canvas.width - width) / 2;

        this.drawImage(context, image, x, x, width, width);
      };
    },

    drawImage(context, image, x, y, width, height, radius = 4) {
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 2;
      context.shadowBlur = 4;
      context.shadowColor = "#00000040";
      context.lineWidth = 8;
      context.beginPath();
      context.moveTo(x + radius, y);
      context.arcTo(x + width, y, x + width, y + height, radius);
      context.arcTo(x + width, y + height, x, y + height, radius);
      context.arcTo(x, y + height, x, y, radius);
      context.arcTo(x, y, x + width, y, radius);
      context.closePath();
      context.strokeStyle = "#fff";
      context.stroke();
      context.clip();
      context.fillStyle = "#fff";
      context.fillRect(x, x, width, height);
      context.drawImage(image, x, x, width, height);
    },
    addToCart() {
      isBtnaddToCartClick.value = 1;
    },
    showImg(index) {
      isBtnshowImgClick.value = 1;

      if (isBtnaddToCartClick.value === 0) {
        this.index = index;
        this.visible = true;
      }
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    handleHide() {
      this.visible = false;
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
      
    },
    async randerDownloadImage(_download_image_type){
      if(_download_image_type === 'ORIGINAL'){
          this.is_download_original_image = "Y"
     }else{
          this.is_download_original_image = "N"
     }  


    }
  },
};
</script>

<style scoped>
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #4bb543;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #4bb543;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}


.align-to-right {
  float: right;
  padding: 10px;
  background-color: hotpink;
}

input[type="checkbox"] {
  display: none;
}



@media screen and (min-width: 451px) and (max-width: 9000px) {
  div.gellerycont {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
    
  }

  div.gellerycont img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gellerycont {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  div.gellerycont img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.gellerycont {
  position: relative;
  width: auto;
  height: auto;
}

.gellerycont img {
  height: auto;
  width: auto;
}

.gellerycont .btn-download {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: hsl(234, 100%, 55%);
  color: white;
  font-size: 13px;
  padding: 5px 14px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
}

.gellerycont .btn-download-logo {
  position: absolute;
  top: 85%;
  left: 71%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: hsl(234, 100%, 55%);
  color: white;
  font-size: 13px;
  padding: 5px 14px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
}

.gellerycont .btn:hover {
  background-color: black;
}
</style>